import React, { useState, useRef, useEffect } from "react";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { Toast } from "primereact/toast";
import { postGeneralApi, getGeneralApi } from "../api/general";
import { Dropdown } from "primereact/dropdown";

export function ProcAsigGestor(props) {
    const { pedido, callBack } = props;
    const overlayPanel = useRef(null);
    const toast = useRef();
    const [datosGestorComercial, setDatosgestorcomercial] = useState({});
    const [gestorComercialDrop, setGestorComercialDrop] = useState(pedido.gestorComercial.id);
    const labelGeneral = "Proceso: " + pedido?.flujo?.nombre;

    async function getListaDatos() {
        await getGeneralApi("listaGestoresComerciales")
            .then((respuesta) => {
                if (respuesta?.data?.success) {
                    setDatosgestorcomercial(respuesta.data.items);
                } else {
                    toast.current.show({ severity: "error", summary: "Error", detail: "Error obteniendo lista de gestores comerciales" });
                }
            })
            .catch((response) => {
                toast.current.show({ severity: "error", summary: "Error", detail: "Error en la petición al servidor" });
            });
    }

    useEffect(() => {
        getListaDatos();
    }, []);

    const onSubmit = (e) => {
        e.preventDefault();
        const datosFormularioEnvio = {
            gestorComercial: { id: gestorComercialDrop },
        };
        postGeneralApi("procAsigGestor", datosFormularioEnvio, pedido.id)
            .then((respuesta) => {
                if (respuesta?.data?.success) {
                    toast.current.show({ severity: "success", summary: "OK", detail: "Envío correcto: " + respuesta?.data?.mensaje });
                    overlayPanel.current.hide();
                    setTimeout(() => {
                        callBack(Date.now());
                    }, 1000);
                } else {
                    toast.current.show({ severity: "error", summary: "Error", detail: "Error en proceso: " + respuesta?.data?.mensaje });
                    overlayPanel.current.hide();
                }
            })
            .catch((response) => {
                console.log("Error API[" + response + "]");
                toast.current.show({ severity: "error", summary: "Error", detail: "Error en la petición al servidor" });
            });
    };

    return (
        <>
            <Toast ref={toast} />
            <Button style={{ width: "100%" }} icon="pi pi-check" className="p-button p-component p-button-outlined p-button-secondary" type="button" label={labelGeneral} onClick={(e) => overlayPanel.current.toggle(e)} />
            <OverlayPanel showCloseIcon dismissable ref={overlayPanel}>
                <form onSubmit={onSubmit}>
                    <div className="card p-fluid">
                        <h5>{labelGeneral}</h5>
                        <p>{pedido?.flujo?.descripcion}</p>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-6">
                                <label htmlFor="gestorComercial">Gestor Comercial</label>
                                <Dropdown name="gestorComercial" optionValue="id" optionLabel="nombreCompleto" value={gestorComercialDrop} options={Array.from(datosGestorComercial)} onChange={(e) => setGestorComercialDrop(e.value)} placeholder="Seleccionar Gestor Comercial" />
                            </div>
                            <div className="p-field">
                                <label htmlFor="actuar" style={{ visibility: "hidden" }}>
                                    Actuar
                                </label>
                                <Button label="Actuar" type="submit"></Button>
                            </div>
                        </div>
                    </div>
                </form>
            </OverlayPanel>
        </>
    );
}
